import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { ToolbarWebElement } from './ToolbarWebElement';
export { ToolbarWebElement };

/**
 * Retrieve an instance of [ToolbarWebElement](../classes/ToolbarWebElement.html).
 * @example
 * ```javascript
 * import { findToolbar } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findToolbar(driver, By.id('my-oj-c-toolbar'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findToolbar(driver: DriverLike, by: By): Promise<ToolbarWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type ToolbarWebElement
  if (!(webEl instanceof ToolbarWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'ToolbarWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findToolbar(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${ToolbarWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-toolbar', ToolbarWebElement);
